"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const verified = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-verified` : '') + (description ? ` desc-verified` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-verified"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-verified"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_18820_7831)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "m8.3 23-2.08-3.5-3.93-.88.38-4.05L0 11.5l2.67-3.07-.38-4.05 3.93-.88L8.29 0 12 1.59 15.7 0l2.08 3.5 3.93.88-.38 4.05L24 11.5l-2.67 3.07.38 4.05-3.93.88-2.07 3.5L12 21.41 8.3 23Zm.7-2 3-1.5 3 1.5 1.5-3 3.5-.5-.5-3.5 2.2-2.5L19.5 9l.5-3-3.5-1L15 2.5l-3 1-3-1L7.5 5 4 6l.5 3-2.2 2.5L4.5 14v3.5l3 .5L9 21Zm1.85-5.61 6.17-6.19L16 8l-5.15 5-2.56-2.8L7 11.5l3.86 3.89Z",
    fill: "#232323"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_18820_7831"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
var _default = exports.default = verified;